<template>
  <v-app class="app-container">
    <Header/>
    <Banner/>
    <CloudBalancer/>
    <Integration/>
<!--    <Tariffs-->
<!--      :pricesProp="prices"-->
<!--      @changeTariff="changeTariffHandler"/>-->
    <PersonalCabinet/>
    <Calc2
      :tariffProp="tariff"
      :pricesProp="prices"
    ></Calc2>
    <Instruction/>
    <About/>
    <Clients/>
    <Footer/>
  </v-app>
</template>

<script>
import Footer from './components/_footer/component';
import Header from './components/_header/component';
import About from './components/about/component';
import Banner from './components/banner/component';
import Calc2 from './components/_calc/component';
import Clients from './components/clients/component';
import Instruction from './components/instruction/component';
import Integration from './components/integration/component';
import PersonalCabinet from './components/personal-cabinet/component';
import CloudBalancer from './components/cloud-balancer/component';
import axios from 'axios';

export default {
  name: 'app',
  components: {
    Header,
    Footer,
    Banner,
    CloudBalancer,
    Integration,
    PersonalCabinet,
    Instruction,
    About,
    Clients,
    Calc2,
  },
  data() {
    return {
      tariff: '',
      prices: null,
    };
  },
  created: function () {
    axios
      .get('https://static.ofd.ru/landing/prices/russtandart.json')
      .then((response) => {
        this.prices = response.data;
        })
      .catch((err) => {
        this.apiErrHandler(err);
      })
  },
  methods: {
    changeTariffHandler: function (val) {
      this.tariff = val;
    }
  }
}
</script>

<style lang="scss">
@import "./styles/styles";
</style>
